export default __webpack_public_path__ + "assets/images/discord-40d7db64a1d90cdd1bfd3205250bba21.svg";